export default {
  path: '/',
  name: 'dashboard',
  component: () => import(/* webpackChunkName: "dashboard" */ './_views/KernelDashboard.vue'),
  meta: {
    title: 'Dashboard',
    navigation: {
      position: 0,
      exact: true,
      name: 'Dashboard',
      icon: 'dashboard',
      specialQueries: ['suffix'],
      to: {
        name: 'dashboard',
        query: {
          suffix: '',
        },
      },
    },
  },
};
